import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import useDeleteNotificationMessageTemplate from 'hooks/notificationMessageTemplate/useDeleteNotificationMessageTemplate';
import { NotificationMessageTemplate } from 'types';
import notificationHandler from 'utils/notifications';

const ModalNotificationMessageTemplateDelete = ({
  opened,
  notificationMessageTemplate,
  handleClose,
}: {
  opened: boolean;
  handleClose: () => void;
  notificationMessageTemplate: NotificationMessageTemplate;
}): JSX.Element => {
  const { mutate, isLoading } = useDeleteNotificationMessageTemplate();
  const { successNotification, errorNotification } = notificationHandler();
  const handleDelete = (): void => {
    mutate(notificationMessageTemplate.notificationMessageTemplateId, {
      onSuccess: () => {
        successNotification(
          'Notification Message Template delete success',
          `${notificationMessageTemplate.description} successfully deleted.`,
        );
      },
      onError: error => {
        errorNotification('Notification Message Template delete failed', error.response?.data.message);
      },
      onSettled: () => {
        handleClose();
      },
    });
  };
  return (
    <Modal
      centered
      opened={opened}
      onClose={handleClose}
      title={<Title order={4}>Delete Notification Message Template</Title>}
      size='auto'
    >
      <Stack>
        <Text>{`Are you sure you want to delete ${notificationMessageTemplate.description} notification message template?`}</Text>
        <Text color='dimmed'>This action cannot be undone.</Text>
        <Group position='right'>
          <Button onClick={handleDelete} color='red' loading={isLoading}>
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalNotificationMessageTemplateDelete;
